import React, { useState } from 'react';
import { useTheme, makeStyles, createStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import { SelectProps as SelectPropsI, TextFieldProps } from 'mui-rff';
import ListSubheader from '@material-ui/core/ListSubheader';
import Button from '@material-ui/core/Button';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import Input from '../Input';

import styles from './Select.module.css';

const popoverClassesSmall = createStyles({
  paper: {
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    maxWidth: '100%',
    maxHeight: 532,
    borderRadius: 8,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
});

const useStyles = makeStyles((theme) => (theme.breakpoints.down('sm') ? popoverClassesSmall : {}));

const renderListSubheader = (title, onClose) => (
  <ListSubheader color="inherit" className={styles.listSubheader}>
    <h2 className={styles.listTitle}>{title}</h2>
    <Button
      color="primary"
      size="small"
      endIcon={<CloseRoundedIcon className={styles.closeIcon} />}
      className={styles.closeListBtn}
      onClick={onClose}
    >
      Close
    </Button>
  </ListSubheader>
);

const listFooter = (
  <div className={styles.listFooter}>
    <div className={styles.gradient} />
    <div className={styles.solidBlock} />
  </div>
);

type OwnProps = {
  SelectProps?: Partial<SelectPropsI>,
}

const Select = ({ children, SelectProps, ...props }: TextFieldProps & OwnProps) => {
  const [open, setOpen] = useState(false);
  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const PopoverClasses = useStyles();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const { label } = props;

  return (
    <Input
      select
      InputProps={{ disableUnderline: true }}
      SelectProps={{
        open,
        onOpen,
        onClose,
        IconComponent: ExpandMoreOutlinedIcon,
        MenuProps: smallScreen
          ? {
            anchorReference: 'none',
            MenuListProps: {
              subheader: renderListSubheader(label, onClose),
            },
            BackdropProps: { invisible: false },
            PaperProps: { elevation: 0 },
            PopoverClasses,
          }
          : { anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            getContentAnchorEl: null,
            style: { maxHeight: '400px' } },
        ...SelectProps,
      }}
      {...props}
    >
      {children}
      {React.Children.count(children) > 8 && listFooter}
    </Input>
  );
};

export default Select;
